//these functions hook into woocommerce jquery triggers for when a variation product is selected etc. 
//the purpose of these functions is to relocate html content that is generated by woocommerce product variations
//as I could not find any hooks that would allow be to do this

// when a variation is selected and shown
$( ".single_variation_wrap" ).on( 'show_variation', function ( event, variation ){
	// if a variation is visible
    if( $('.single_variation:visible') ){
    	//if stock / price has already been added 
    	if( $('.variations .stock').length ){
            var stock = $('.woocommerce-variation-availability').html(); //get current product stock html
            $('.variations .stock').replaceWith(stock); //replace stock html for last product with new prod stock html

    		var price = $('.woocommerce-variation-price').html();//get current product price
	    	$('.woocommerce-variation-add-to-cart .price').replaceWith(price); //replace old price with new
    	}else{
            var stock = $('.woocommerce-variation-availability').html();//get product stock html
            $('.variations').append(stock);//relocate product stock html

	    	var price = $('.woocommerce-variation-price').html(); //get product price
	    	$('.quantity').before(price); //relocate new price
    	}
    }
} );

// when an option is selected and no variation is available for that option
$( ".single_variation_wrap" ).on( 'hide_variation', function( event, variation ){
    $('.woocommerce-variation-add-to-cart .price').remove(); //remove price as no product is showing
    $('.variations .stock').remove();//remove stock
}); 


    

































































































